import React from "react";
import { Route } from "react-router-dom";
import { IonRouterOutlet } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { connect } from "react-redux";

import InternalLayout from "layouts/Internal";
import FrontendLayout from "layouts/Frontend";

// import Register from "../pages/Auth/Register";
// import ForgotPassword from "../pages/Auth/ForgotPassword";

import Login from "pages/Auth/Login";

// import Loading from "components/Loading";

interface Props {}

const Routing: React.FC<Props> = () => {
  return (
    <IonReactRouter>
      {/* <Loading /> */}
      {/* <NotificationPopOver /> */}
      <IonRouterOutlet>
        <Route exact path="/login">
          <FrontendLayout>
            <Login />
          </FrontendLayout>
        </Route>
        {/* <Route path="/register" component={Register} exact />
        <Route path="/forgotpassword" component={ForgotPassword} exact /> */}
        <InternalLayout />
      </IonRouterOutlet>
    </IonReactRouter>
  );
};

const mapStateToProps = (state: any) => ({
  // loggedIn: state.user.loggedIn,
});

export default connect(mapStateToProps, {})(Routing);
